import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent implements OnInit {
  @Input() count: string;
  @Input() icon: string;
  @Input() name: string;
  @Input() size: string = 'md';
  @Input() ariaLabel: string;

  constructor() {}

  ngOnInit() {
    const doc = document.getElementById('svgElement');
    if (doc && doc.parentElement) {
      doc.setAttribute('viewBox', `0 0 ${doc.parentElement.clientWidth} ${doc.parentElement.clientHeight}`);
    }
  }
}
